export function convertColor(color) {
    if (/^#([A-Fa-f0-9]{8})$/.test(color)) {
      const a = parseInt(color.slice(1, 3), 16) / 255;
      const r = parseInt(color.slice(3, 5), 16);
      const g = parseInt(color.slice(5, 7), 16);
      const b = parseInt(color.slice(7, 9), 16);
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    }
    return color;
  }
